module.exports = __webpack_public_path__ + "img/룰렛.5b3c4029.png";